/**
 * 미리듣기 audio 공통 유틸 — Phase B 단계 5 (FU-7) 추출.
 *
 * 사용처: `useVoicePresetPreview` 훅, `VoicePresetFormDialog` 라이브 미리듣기,
 * 추후 추가될 카드 그리드 미리듣기.
 */

/**
 * Tempo (playbackRate) 변경 시 피치가 같이 변하지 않도록 강제.
 * HTMLAudioElement 표준 `preservesPitch` + 구형 브라우저 vendor prefix.
 */
export function setPreservesPitch(audio: HTMLAudioElement, value: boolean) {
  audio.preservesPitch = value;
  (
    audio as HTMLAudioElement & { mozPreservesPitch?: boolean }
  ).mozPreservesPitch = value;
  (
    audio as HTMLAudioElement & { webkitPreservesPitch?: boolean }
  ).webkitPreservesPitch = value;
}

/**
 * payload `languageCode` 우선, 없으면 `locale` 기반으로 TTS language enum 결정.
 *
 * - `languageCode === 'en'` → ENGLISH
 * - 명시 없음 + locale 이 'ko' 외 → ENGLISH
 * - 그 외 → KOREAN
 *
 * BE `voicePreview` / `voice/url` 양쪽 모두 동일한 분기를 요구.
 */
export function localeToLanguage(
  locale: string,
  languageCode?: string | null,
): 'KOREAN' | 'ENGLISH' {
  if (languageCode === 'en') return 'ENGLISH';
  if (!languageCode && locale !== 'ko') return 'ENGLISH';
  return 'KOREAN';
}
